import { currencyFormat } from '../currencyFormat/currencyFormat'
import { formatNumberWithCommas } from '../formatNumberWithCommas/formatNumberWithCommas'

export function buildPriceString({
  currencySymbol,
  lowPrice,
  highPrice,
  locale,
  iso,
  bonhamsCode,
}: BuildPriceStringProps) {
  const hasAHighAndLowEstimate = !!highPrice && !!lowPrice
  const hasAFlatEstimateValue = highPrice === lowPrice
  const hasOnlyALowEstimateValue = !!lowPrice && !highPrice
  const hasOnlyAHighEstimateValue = !!highPrice && !lowPrice
  const isLocalPrice = !!locale && !!iso && !!bonhamsCode

  let priceString = ''

  if (
    (hasAHighAndLowEstimate ||
      hasAFlatEstimateValue ||
      hasOnlyALowEstimateValue) &&
    lowPrice
  ) {
    if (isLocalPrice) {
      priceString = `${priceString}${currencyFormat({
        value: lowPrice,
        iso: iso,
        locale: locale,
        bonhamsCode: bonhamsCode,
      })}`
    } else {
      priceString = `${priceString}${currencySymbol}${formatNumberWithCommas(lowPrice)}`
    }
  }

  if (!hasAFlatEstimateValue && hasAHighAndLowEstimate) {
    priceString = `${priceString} - `
  }

  if (
    !hasAFlatEstimateValue &&
    (hasAHighAndLowEstimate || hasOnlyAHighEstimateValue)
  ) {
    if (isLocalPrice) {
      priceString = `${priceString}${currencyFormat({
        value: highPrice,
        iso: iso,
        locale: locale,
        bonhamsCode: bonhamsCode,
      })}`
    } else {
      priceString = `${priceString}${currencySymbol}${formatNumberWithCommas(highPrice)}`
    }
  }

  return priceString
}

type BuildPriceStringProps = NormalPriceProps | LocalePriceProps

interface NormalPriceProps {
  currencySymbol: string
  lowPrice?: number
  highPrice?: number
  locale?: never
  iso?: never
  bonhamsCode?: never
}

interface LocalePriceProps {
  currencySymbol?: never
  lowPrice?: number
  highPrice?: number
  locale: string
  iso: string
  bonhamsCode: string
}
